import { getFlags, servicesDict } from '@rr-components/shared-fsd/shared/utils/config'

const featuresDict = {
  baseUrl: 'ui.new-app-url',
  newYearDesign: 'ui.new-year-design'
}

const featuresList = Object.values(featuresDict)

export const features = {
  namespaced: true,
  state: {
    featuresDict: {},
    tenant: null
  },
  mutations: {
    setupFeatures (state, features) {
      state.featuresDict = features
    },
    setTenant (state, tenant) {
      state.tenant = tenant
    }
  },
  getters: {
    newAppUrl: (state) => {
      if (state.tenant !== 'rr') return null

      return state.featuresDict[featuresDict.baseUrl] || 'reg.rr-dev.ru'
    },
    newYearFeatureEnabled: (state) => {
      if (state.tenant !== 'rr') return false

      return state.featuresDict[featuresDict.newYearDesign] || false
    }
  },
  actions: {
    setTenant ({ commit }, tenant) {
      commit('setTenant', tenant)
    },
    async setupFeatures ({ state, commit }) {
      if (state.tenant !== 'rr') return

      const features = await getFlags(featuresList, state.tenant, servicesDict.clubs)
      commit('setupFeatures', features)
    }
  }
}
